export enum TypeDeclaration {
  CONSOLIDEE = 'CONSOLIDEE',
  INDIVIDUELLE = 'INDIVIDUELLE',
}